/**
 * CreditHQ-only palettes (locked theme). Kept out of @aiapollo/design-system so skins stay bounded.
 *
 * Blues / cyans are aligned to the official mark (`media/credithq-mark-source.jpg` /
 * https://www.credithq.ai/credithq-logo.png): sampled foreground percentiles → a
 * coherent fintech scale. Semantic accents stay distinct but slightly cooled to
 * sit next to the brand blues.
 */

import type { FlatUiPalette } from "@aiapollo/design-system"

export const CREDITHQ_LIGHT_PALETTE: FlatUiPalette = {
	id: "credithq",
	name: "CreditHQ",
	icon: "🏦",
	colors: [
		{ name: "Slate 950", hex: "#020617" },
		{ name: "Slate 900", hex: "#0f172a" },
		{ name: "Slate 800", hex: "#1e293b" },
		/* Brand blues (from mark) */
		{ name: "CHQ Midnight", hex: "#021730" },
		{ name: "CHQ Deep", hex: "#1a577f" },
		{ name: "CHQ Core", hex: "#2ba5ce" },
		{ name: "CHQ Mid", hex: "#4f9db7" },
		{ name: "CHQ Ice", hex: "#99dfe5" },
		{ name: "CHQ Mist", hex: "#d2f6f7" },
		{ name: "CHQ Canvas", hex: "#becfd6" },
		/* Supporting accents */
		{ name: "Teal 500", hex: "#14b8a6" },
		{ name: "Emerald 500", hex: "#10b981" },
		{ name: "Amber 400", hex: "#f5c563" },
		{ name: "Orange 500", hex: "#ea8540" },
		{ name: "Rose 500", hex: "#e8556d" },
		{ name: "Red 600", hex: "#dc2626" },
		{ name: "Slate 300", hex: "#cbd5e1" },
		{ name: "Slate 400", hex: "#94a3b8" },
		{ name: "Slate 500", hex: "#64748b" },
		{ name: "Slate 100", hex: "#f1f5f9" },
	],
}

export const CREDITHQ_DARK_PALETTE: FlatUiPalette = {
	id: "credithq-dark",
	name: "CreditHQ Dark",
	icon: "🌙",
	colors: [
		{ name: "Slate 950", hex: "#020617" },
		{ name: "Slate 900", hex: "#0f172a" },
		{ name: "Slate 800", hex: "#1e293b" },
		{ name: "Slate 700", hex: "#334155" },
		{ name: "CHQ Ice", hex: "#99dfe5" },
		{ name: "CHQ Core", hex: "#2ba5ce" },
		{ name: "CHQ Mist", hex: "#d2f6f7" },
		{ name: "CHQ Mid", hex: "#4f9db7" },
		{ name: "Teal 400", hex: "#2dd4bf" },
		{ name: "Emerald 400", hex: "#34d399" },
		{ name: "Amber 300", hex: "#fcd34d" },
		{ name: "Orange 400", hex: "#fb923c" },
		{ name: "Rose 400", hex: "#fb7185" },
		{ name: "Red 500", hex: "#ef4444" },
		{ name: "Slate 500", hex: "#64748b" },
		{ name: "Slate 400", hex: "#94a3b8" },
		{ name: "Slate 300", hex: "#cbd5e1" },
		{ name: "Slate 200", hex: "#e2e8f0" },
		{ name: "Slate 100", hex: "#f1f5f9" },
		{ name: "White", hex: "#f8fafc" },
	],
}
